import React, { useState } from 'react';
import TokenGroup from './TokenGroup';
import Token from './Token';
import { FaChevronDown } from 'react-icons/fa';
import { IconContext } from 'react-icons';

function SelectedFilter(props) {
  const tokenGroupWrapperClass = "flex flex-col items-center bg-gray-100 border-2 m-1 p-1 rounded-lg";
  const tokenClass = "flex items-baseline justify-between pr-2 bg-gray-600 text-white rounded-full cursor-pointer hover:bg-red-800 hover:shadow";
  const tokenWrapperClass = "w-full";
  const [show, setShow] = useState(false);

  function countFilters() {
    let filterCount = 0;

    filterCount += props.searchForm.regionIds.length;
    filterCount += props.searchForm.shipIds.length;
    filterCount += props.searchForm.cruiselineIds.length;

    if (props.searchForm.priceMax > 0) filterCount++;

    props.searchForm.cabins.map((cabin) => {
      filterCount += cabin.cabintypeIds.length;
      if (cabin.persons.adults > 0) filterCount++;
      if (cabin.persons.seniors > 0) filterCount++;
      if (cabin.persons.children > 0) filterCount++;
      if (cabin.persons.juniorChildren > 0) filterCount++;
      if (cabin.persons.infants > 0) filterCount++;
    });

    if (props.searchForm.departureMin > 0) filterCount++;
    if (props.searchForm.departureMax > 0) filterCount++;
    if (props.searchForm.durationMin > 0) filterCount++;
    if (props.searchForm.durationMax > 0) filterCount++;

    filterCount += props.searchForm.departureStoppointIds.length;
    filterCount += props.searchForm.onRouteStoppointIds.length;
    filterCount += props.searchForm.arrivalStoppointIds.length;
    if (props.searchForm.roundtrip) filterCount++;

    return filterCount;
  }
  
  return (
    <React.Fragment>
      <div className="flex">
        <div className="border p-2 rounded-lg cursor-pointer hover:text-blue-700" onClick={() => setShow(!show)}>
          <div className="flex items-baseline">
            <span className="text-base pr-2 whitespace-no-wrap">Selected filter</span>
            <IconContext.Provider value={{ size: "0.75em", className: "text-black hover:text-red-300" }}>
              <FaChevronDown />
            </IconContext.Provider>
          </div>

        </div>
        <div className="pl-2">
          <span className="bg-orange-600 rounded-full px-2 py-1 text-white text-xs ">{countFilters()}</span>
        </div>
        {
          show ?
            <div className="absolute bg-white p-4 z-50 border-2 rounded-lg" style={{ top: 60 }}>
              <div className="flex flex-wrap ">
                {props.searchForm.cabins.map((cabin, index) =>
                  <div key={'cabin_' + cabin.id} className={tokenGroupWrapperClass}>
                    <div className="flex items-baseline justify-between pr-2 cursor-pointer rounded-full hover:bg-red-800 hover:shadow hover:text-white">
                      <span className="whitespace-no-wrap "
                        onClick={() => { props.handleClick("cabinId", cabin.id) }}>Cabin #{index + 1}:</span>
                      <svg className="inline fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <title>Token</title>
                        <path d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                      </svg>
                    </div>
                    {cabin.persons.adults > 0
                      ? <div className="flex flex-col-reverse pr-2">
                        <Token tokenClass={tokenClass}
                          tokenId="adults"
                          value={"Adults: " + cabin.persons.adults}
                          onClick={() => { props.handleClick("adults", cabin.id) }}
                        />
                      </div>
                      : null
                    }
                    {cabin.persons.seniors > 0
                      ? <div className="flex flex-col-reverse pr-2">
                        <Token tokenClass={tokenClass}
                          tokenId="seniors"
                          value={"Seniors: " + cabin.persons.seniors}
                          onClick={() => { props.handleClick("seniors", cabin.id) }}
                        />
                      </div>
                      : null
                    }
                    {cabin.persons.children > 0
                      ? <div className="flex flex-col-reverse pr-2">
                        <Token tokenClass={tokenClass}
                          tokenId="children"
                          value={"Children: " + cabin.persons.children}
                          onClick={() => { props.handleClick("children", cabin.id) }}
                        />
                      </div>
                      : null
                    }
                    {cabin.persons.juniorChildren > 0
                      ? <div className="flex flex-col-reverse pr-2">
                        <Token tokenClass={tokenClass}
                          tokenId="juniorChildren"
                          value={"Junior-children: " + cabin.persons.juniorChildren}
                          onClick={() => { props.handleClick("juniorChildren", cabin.id) }}
                        />
                      </div>
                      : null
                    }
                    {cabin.persons.infants > 0
                      ? <div className="flex flex-col-reverse pr-2">
                        <Token tokenClass={tokenClass}
                          tokenId="infants"
                          value={"Infants: " + cabin.persons.infants}
                          onClick={() => { props.handleClick("infants", cabin.id) }}
                        />
                      </div>
                      : null
                    }
                    {cabin.cabintypeIds.length > 0 && props.searchFormArrays.cabinprimarytypes.length > 0
                      ? <TokenGroup tokenClass={tokenClass}
                        groupLabel="Cabintype:"
                        selectedIds={cabin.cabintypeIds}
                        nameCollection={props.searchFormArrays.cabinprimarytypes}
                        onClick={(e) => { props.handleClick("cabintypeId", e, cabin.id) }} />
                      : null
                    }
                  </div>
                )}
                {props.searchForm.regionIds.length > 0 && props.searchFormArrays.regions.length > 0
                  ? <TokenGroup
                    tokenGroupWrapperClass={tokenGroupWrapperClass}
                    tokenClass={tokenClass}
                    groupLabel="Destinations:"
                    selectedIds={props.searchForm.regionIds}
                    nameCollection={props.searchFormArrays.regions}
                    onClick={(e) => { props.handleClick("regionId", e) }} />
                  : null
                }
                {props.searchForm.shipIds.length > 0 && props.searchFormArrays.ships.length > 0
                  ? <TokenGroup
                    tokenGroupWrapperClass={tokenGroupWrapperClass}
                    tokenClass={tokenClass}
                    groupLabel="Ships:"
                    selectedIds={props.searchForm.shipIds}
                    nameCollection={props.searchFormArrays.ships}
                    onClick={(e) => { props.handleClick("shipId", e) }} />
                  : null
                }
                {props.searchForm.cruiselineIds.length > 0 && props.searchFormArrays.cruiselines.length > 0
                  ? <TokenGroup
                    tokenGroupWrapperClass={tokenGroupWrapperClass}
                    tokenClass={tokenClass}
                    groupLabel="Operators:"
                    selectedIds={props.searchForm.cruiselineIds}
                    nameCollection={props.searchFormArrays.cruiselines}
                    onClick={(e) => { props.handleClick("cruiselineId", e) }} />
                  : null
                }
                {props.searchForm.departureMin || props.searchForm.departureMax ?
                  <div className="flex flex-col items-center bg-gray-100 border-2 m-1 p-1 rounded-lg">
                    <span>Departure:</span>
                    {props.searchForm.departureMin
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="departureMin"
                          value={"Earliest: " + new Intl.DateTimeFormat("en-GB", {
                            day: "2-digit",
                            month: "long"
                          })
                            .format(new Date(props.searchForm.departureMin))
                          }
                          onClick={() => { props.handleClick("departureMin") }}
                        />
                      </div>
                      : null
                    }
                    {props.searchForm.departureMax
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="departureMax"
                          value={"Latest: " + new Intl.DateTimeFormat("en-GB", {
                            day: "2-digit",
                            month: "long"
                          })
                            .format(new Date(props.searchForm.departureMax))
                          }
                          onClick={() => { props.handleClick("departureMax") }}
                        />
                      </div>
                      : null
                    }
                  </div>
                  : null
                }
                {(props.searchForm.departureStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0)
                  || (props.searchForm.onRouteStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0)
                  || (props.searchForm.arrivalStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0)
                  ?
                  <div className="flex flex-col bg-gray-100 border-2 m-1 p-1 rounded-lg">
                    {props.searchForm.departureStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0
                      ? <TokenGroup tokenClass={tokenClass}
                        groupLabel="Departure from:"
                        selectedIds={props.searchForm.departureStoppointIds}
                        nameCollection={props.searchFormArrays.stoppoints}
                        onClick={(e) => { props.handleClick("departureStoppointId", e) }} />
                      : null
                    }
                    {props.searchForm.onRouteStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0
                      ? <TokenGroup tokenClass={tokenClass}
                        groupLabel="Including port:"
                        selectedIds={props.searchForm.onRouteStoppointIds}
                        nameCollection={props.searchFormArrays.stoppoints}
                        onClick={(e) => { props.handleClick("onRouteStoppointId", e) }} />
                      : null
                    }
                    {props.searchForm.arrivalStoppointIds.length > 0 && props.searchFormArrays.stoppoints.length > 0
                      ? <TokenGroup tokenClass={tokenClass}
                        groupLabel="Arrival at:"
                        selectedIds={props.searchForm.arrivalStoppointIds}
                        nameCollection={props.searchFormArrays.stoppoints}
                        onClick={(e) => { props.handleClick("arrivalStoppointId", e) }} />
                      : null
                    }
                  </div>
                  : null
                }
                {props.searchForm.durationMin > 0 || props.searchForm.durationMax > 0
                  ? <div className="flex flex-col items-center bg-gray-100 border-2 m-1 p-1 rounded-lg">
                    <span>Duration:</span>
                    {props.searchForm.durationMin > 0
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="durationMin"
                          value={"Nights (min): " + props.searchForm.durationMin}
                          onClick={() => { props.handleClick("durationMin") }}
                        />
                      </div>
                      : null
                    }
                    {props.searchForm.durationMax > 0
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="durationMax"
                          value={"Nights (max): " + props.searchForm.durationMax}
                          onClick={() => { props.handleClick("durationMax") }}
                        />
                      </div>
                      : null
                    }
                  </div>
                  : null
                }
                {props.searchForm.priceMax > 0 || props.searchForm.roundtrip
                  ?
                  <div className="flex flex-col items-center bg-gray-100 border-2 m-1 p-1 rounded-lg">
                    <span>Extra filters</span>
                    {props.searchForm.priceMax > 0
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="priceMax"
                          value={"Max price: " + props.searchForm.priceMax}
                          onClick={() => { props.handleClick("priceMax") }}
                        />
                      </div>
                      : null
                    }
                    {props.searchForm.roundtrip
                      ? <div className={tokenWrapperClass}>
                        <Token tokenClass={tokenClass}
                          tokenId="roundtrip"
                          value="Roundtrip only"
                          onClick={() => { props.handleClick("roundtrip") }}
                        />
                      </div>
                      : null
                    }
                  </div>
                  : null
                }
              </div>
            </div>
            : null
        }
      </div>
    </React.Fragment>
  );
}

export default SelectedFilter;